import { __assign, __rest } from "tslib";
import React from 'react';
import Table from 'rc-table';
import classnames from 'classnames';
import './index.scss';
/**
 * @category 组件
 * @description mini表格
 */
export var CnMiniTable = function (props) {
    var _a;
    var prefixCls = 'cn-ui-m-mini-table';
    var hasBorder = props.hasBorder, className = props.className, rest = __rest(props, ["hasBorder", "className"]);
    var cls = classnames((_a = {},
        _a["".concat(prefixCls, "-has-border")] = hasBorder,
        _a.className = className,
        _a));
    return (React.createElement("div", { className: "".concat(prefixCls, "-wrap") },
        React.createElement(Table, __assign({ className: cls, prefixCls: prefixCls }, rest))));
};
CnMiniTable.defaultProps = {
    hasBorder: true,
};
CnMiniTable.displayName = 'CnMiniTable';
